import React from "react";
import CtaButton from "../../../components/Buttons/CtaButton/CtaButton";
import StyledLgText from "../../../common/components/styledLgText/StyledLgText";
import StyledH3Heading from "../../../common/components/styledH3Heading/StyledH3Heading";
import { useNavigate } from 'react-router-dom';

const styles = {
  backgroundRepeat: "no-repeat",
  backgroundImage: `
      url('/assets/chain.svg'), 
      url('/assets/golden-tiers-shadow.svg')
    `,
  backgroundPosition: "right top, left top",
};

const GoldenTiersSection = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/collection');
  }
  return (
    <div style={styles} className="w-full flex justify-center items-center ">
      <div className="w-[90%] sm:w-[85%] md:w-[80%] flex flex-col md:flex-row justify-between items-center gap-20 py-20">
        <div className="flex flex-col gap-6 items-start pt-10 md:pt-0  md:w-[43.8%]">
          <div className="space-y-1 lg:pr-10">
            <StyledH3Heading fontColor={"textGradient"}>
              5 Golden Tiers
            </StyledH3Heading>
            <StyledLgText >
              We created a small batch of different options to keep a low
              circulation of art for a stronger profit margin towards your
              initial investment. We could have made over 10,000 units, but why
              over-saturate the rarity of these beauties?
            </StyledLgText>
          </div>
          <div>
            <CtaButton children={"Golden Collection"} onClick={handleClick}/>
          </div>
        </div>
        <div className="md:grid grid-cols-2 grid-rows-2 gap-2 md:gap-4 hidden ">
          <div className="block relative w-[120px] h-[160px] md:w-[160] md:h-[190] lg:w-[221px] lg:h-[264px]">
            <img
              src="/assets/golden-tire-1.png"
              alt=""
              className="yellow-border"
            />
            <div className="">
              <img
                src="/assets/jelly-star.svg"
                alt="Jelly Star"
                className="absolute bottom-2 md:-bottom-8 -left-8 md:-left-16 max-w-12 md:max-w-20 xl:max-w-full"
              />
            </div>
          </div>
          <div className="self-end tires-collection w-[100px] h-[130px] lg:w-[145px] lg:h-[173px]">
            <img
              src="/assets/golden-tire-2.png"
              alt=""
              className="yellow-border"
            />
          </div>
          <div className="justify-self-end w-[100px] h-[130px] lg:w-[145px] lg:h-[173px]">
            <img
              src="/assets/golden-tire-3.png"
              alt=""
              className="yellow-border"
            />
          </div>
          <div className="w-[120px] h-[160px] md:w-[160] md:h-[190] lg:w-[221px] lg:h-[264px]">
            <img
              src="/assets/golden-tire-4.png"
              alt=""
              className="yellow-border"
            />
          </div>
        </div>
        <div className="md:hidden">
          <img src="/assets/5-golden-tires-mobile.png" alt="Golden Tiers" className="w-full" loading="lazy"/>
        </div>
      </div>
    </div>
  );
};

export default GoldenTiersSection;
